import { Action } from '@ngrx/store';
import {
    EMPLOYEES_SUGGESTIONS_FETCH,
    SETTINGS_FETCH,
    SETTINGS_FETCHING_SET,
    SETTINGS_SET,
    SETTINGS_UPDATE,
    SETTINGS_TIPS_SET,
    SETTINGS_LEAVEPOLICIES_FETCH,
    SETTINGS_LEAVEPOLICY_VIEWED_SET,
    SETTINGS_LEAVEPOLICY_FETCH,
    SETTINGS_LEAVEPOLICY_EMPLOYEES_UPDATE,
    SETTINGS_LEAVEPOLICY_NEW_UPDATE,
    SETTINGS_LEAVEPOLICY_NEW_RESET,
    SETTINGS_LEAVEPOLICY_CREATE,
    SETTINGS_TIMEOFF_TYPES_FETCH,
    SETTINGS_TIMEOFF_TYPES_RESET,
    SETTINGS_TIMEOFF_TYPES_SET
} from '../action-types';
import { ObservableAction } from '../shared/actions/observable-action';
import { ListItemSetAction, ListSetAction, ListSetFetchingAction } from '../shared/list/list.actions';
import { GROUP_EMPLOYEE_SUGGESTIONS, GROUP_SETTINGS_LEAVE_POLICIES } from '../state-groups';
import { EMPLOYEE_ENTITY, LEAVE_POLICY_ENTITY } from '../entity-types';
import { SharedAction } from '../shared/actions/shared-action';
import { CreateLeavePolicyRequest } from '@core/models/leave/create-leave-policy-request';
import { TimeOffType } from '@core/models/time-off/time-off-type';

export class FetchSettingsAction implements Action {
    readonly type = SETTINGS_FETCH;
}

export class SetSettingsAction implements Action {
    readonly type = SETTINGS_SET;

    constructor(public payload: { settings: any }) {}
}

export class SetFetchingSettingsAction implements Action {
    readonly type = SETTINGS_FETCHING_SET;

    constructor(public payload: boolean) {}
}

export class SetTipsAction implements Action {
    readonly type = SETTINGS_TIPS_SET;
}

@ObservableAction()
export class UpdateSettingsAction implements Action {
    readonly type = SETTINGS_UPDATE;

    constructor(public payload: { settings: any }) {}
}

// Employee suggestions
export class FetchEmployeeSuggestionsAction implements Action {
    readonly type = EMPLOYEES_SUGGESTIONS_FETCH;

    constructor() {}
}

export class SetEmployeeSuggestionsAction extends ListSetAction implements Action {
    name = GROUP_EMPLOYEE_SUGGESTIONS;

    constructor(payload: any) {
        super(payload);
        payload.domain = EMPLOYEE_ENTITY;
    }
}

export class SetEmployeeSuggestionsFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_EMPLOYEE_SUGGESTIONS;

    constructor(payload: any) {
        super(payload);
    }
}

// Leaves
export class FetchLeavePoliciesAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICIES_FETCH;
}

export class SetLeavePoliciesAction extends ListSetAction implements Action {
    name = GROUP_SETTINGS_LEAVE_POLICIES;

    constructor(payload: any) {
        super(payload);
        payload.domain = LEAVE_POLICY_ENTITY;
    }
}

export class SetLeavePoliciesFetchingAction
    extends ListSetFetchingAction
    implements SharedAction {
    name = GROUP_SETTINGS_LEAVE_POLICIES;

    constructor(payload: any) {
        super(payload);
   }
}

export class FetchLeavePolicyAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_FETCH;

    constructor(
        public payload: {
            id: string;
        }
    ) {}
}

export class SetLeavePolicyAction extends ListItemSetAction implements SharedAction {
    name = GROUP_SETTINGS_LEAVE_POLICIES;

    constructor(payload: any) {
        super(payload);
        payload.domain = LEAVE_POLICY_ENTITY;
    }
}

export class SetViewedLeavePolicyAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_VIEWED_SET;

    constructor(
        public payload: {
            id: string;
        }
    ) {}
}

@ObservableAction()
export class UpdateLeavePolicyEmployeesAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_EMPLOYEES_UPDATE;

    constructor(public payload: { id: string, request: any }) {}
}

@ObservableAction()
export class CreateLeavePolicyAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_CREATE;

    constructor(public payload: { request: CreateLeavePolicyRequest }) {}
}   

export class UpdateNewLeavePolicyAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_NEW_UPDATE;

    constructor(public payload: any) {}
}

export class ResetNewLeavePolicyAction implements Action {
    readonly type = SETTINGS_LEAVEPOLICY_NEW_RESET;
}

//  Time offs
export class FetchTimeoffTypesAction implements Action {
    readonly type = SETTINGS_TIMEOFF_TYPES_FETCH;
}

export class SetTimeoffTypesAction implements Action {
    readonly type = SETTINGS_TIMEOFF_TYPES_SET;

    constructor(public payload: { types: TimeOffType[] }) {}
}

export class ResetTimeoffTypesAction implements Action {
    readonly type = SETTINGS_TIMEOFF_TYPES_RESET;
}
